import React, { useMemo } from "react";
import moment from "moment";
import { CircleCheckmark } from "../../../../assets/icons";
import { WorkflowEvent, getEventStatusText } from "../../../../service/customer/order-workflow-service";
import styles from "../solar-journey.module.scss";

interface Props {
	events: WorkflowEvent[];
}

interface DateGroup {
	date: string;
	items: WorkflowEvent[];
}

const groupEventsByDate = (events: WorkflowEvent[]): DateGroup[] => {
	const groups: DateGroup[] = [];

	for (const event of events) {
		const date = moment(event.timestamp).format("dddd, Do MMM YYYY");
		const lastGroup = groups[groups.length - 1];
		if (lastGroup && lastGroup.date === date) {
			lastGroup.items.push(event);
		} else {
			groups.push({ date, items: [event] });
		}
	}

	return groups;
};

export const StatusTimeline: React.FC<Props> = ({ events }) => {
	const groupedEvents = useMemo(() => groupEventsByDate(events), [events]);

	if (!events?.length) {
		return (
			<div className={styles.timelineCard}>
				<span className={styles.timelineEventName}>No events yet</span>
			</div>
		);
	}

	return (
		<div className={styles.timelineCard}>
			{groupedEvents.map((group, groupIdx) => (
				<div key={groupIdx} className={styles.timelineSectionActive}>
					<div className={styles.timelineDateHeader}>{group.date}</div>
					<div className={styles.timelineEvents}>
						{group.items.map((event, eventIdx) => (
							<div key={`${groupIdx}-${eventIdx}`} className={styles.timelineEvent}>
								<div className={styles.timelineEventLeft}>
									<CircleCheckmark />
									<span className={styles.timelineEventName}>{getEventStatusText(event)}</span>
								</div>
								<span className={styles.timelineEventTime}>
									{moment(event.timestamp).format("H:mm A")}
								</span>
							</div>
						))}
					</div>
				</div>
			))}
		</div>
	);
};
